import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
    const { user } = useAuth();
    if (user === null) {
        return (
            <div className="flex min-h-screen items-center justify-center text-neutral-500 font-mono text-sm">
                Authenticating…
            </div>
        );
    }
    if (!user) return <Navigate to="/admin/login" replace />;
    return children;
}
